

/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard'
  },
  // {
  //   path: '/user-profile',
  //   name: 'User Profile',
  //   view: 'UserProfile'
  // },
  // {
  //   path: '/table-list',
  //   name: 'Table List',
  //   view: 'TableList'
  // },
  // {
  //   path: '/typography',
  //   view: 'Typography'
  // },
  // {
  //   path: '/icons',
  //   view: 'Icons'
  // },
  // {
  //   path: '/maps',
  //   view: 'Maps'
  // },
  // {
  //   path: '/notifications',
  //   view: 'Notifications'
  // },
  // {
  //   path: '/upgrade',
  //   name: 'Upgrade to PRO',
  //   view: 'Upgrade'
  // }, 
  {
    path: '/customer',
    name: 'Customer',
    view: 'Customer'
  }, 
  {
    path: '/customer-detail/:id',
    name: 'Customer Detail',
    view: 'CustomerDetail'
  }, 
  {
    path: '/customer-edit',
    name: 'Customer Edit',
    view: 'CustomerEdit'
  },
  {
    path: '/commission',
    name: 'Commission',
    view: 'Commission'
  },
  {
    path: '/commission-detail',
    name: 'Commission Detail',
    view: 'CommissionDetail'
  }, 
  {
    path: '/banking',
    name: 'Banking',
    view: 'Banking'
  }, 
  {
    path: '/settings',
    name: 'Settings',
    view: 'Settings',
    children: [
      {
        // A will be rendered in the second <router-view>
        // when /your-sidebar-url/a is matched
        name: 'Profile',
        path: '',
        view: "Profile"
      },
      {
        // A will be rendered in the second <router-view>
        // when /your-sidebar-url/a is matched
        name: 'Profile',
        path: '/settings/profile',
        view: "Profile"
      },
      {
        // B will be rendered in the second <router-view>
        // when /your-sidebar-url/b is matched
        name: 'Users and Teams',
        path: '/settings/users-and-teams',
        view: "UsersAndTeams"
      },
      {
        // B will be rendered in the second <router-view>
        // when /your-sidebar-url/b is matched
        name: 'Billing',
        path: '/settings/billing',
        view: "Billing"
      }
    ]
  }, 
  {
    path: '/help',
    name: 'Help',
    view: 'Help'
  }, 
  {
    path: '/admin',
    name: 'Admin',
    view: 'Admin',
    children: [
      {
        name: 'Account',
        path: '',
        view: "Account"
      },
      {
        name: 'Account',
        path: '/admin/account',
        view: "Account"
      },
      {
        name: 'Coverages',
        path: '/admin/coverages',
        view: "Coverages"
      }
    ]
  }, 
  {
    path: '/logout',
    name: 'Logout',
    view: 'Logout'
  }, 
  {
    path: '/login',
    name: 'Login',
    view: 'Login'
  }
]
